<template>
  <div class="detail-page-return">
    <div class="top-page-all">
      <div @click="onClickLeft" class="ret-btn"><</div>
      <div>客户回访</div>
    </div>

    <div class="content-box">
      <van-cell-group>
        <div class="van-cell van-field">
          <div class="van-cell__title van-field__label">
            <span>用户名</span>
          </div>
          <div class="van-cell__value">
            <div class="van-field__body">
              <div class="field__control">{{info.realname}}</div>
            </div>
          </div>
        </div>

        <div class="van-cell van-field">
          <div class="van-cell__title van-field__label">
            <span>手机号</span>
          </div>
          <div class="van-cell__value">
            <div class="van-field__body">
              <div class="field__control">{{info.phone}}</div>
            </div>
          </div>
        </div>

        <div class="van-cell van-field">
          <div class="van-cell__title van-field__label">
            <span>简介</span>
          </div>
          <div class="van-cell__value">
            <div class="van-field__body">
              <div style="text-align: left;" class="field__control">{{info.simple}}</div>
            </div>
          </div>
        </div>



       <div class="van-cell van-field">
          <div class="van-cell__title van-field__label">
            <span>状态</span>
          </div>
          <div class="van-cell__value">
            <div class="van-field__body">
              <div style="text-align: left;" class="field__control"> {{ info.status | statusMap }}</div>
            </div>
          </div>
        </div>


               <div class="van-cell van-field">
          <div class="van-cell__title van-field__label">
            <span>生日</span>
          </div>
          <div class="van-cell__value">
            <div class="van-field__body">
              <div style="text-align: left;" class="field__control">{{info.year}}-{{info.month}}</div>
            </div>
          </div>
        </div>


               <div class="van-cell van-field">
          <div class="van-cell__title van-field__label">
            <span>性别</span>
          </div>
          <div class="van-cell__value">
            <div class="van-field__body">
              <div style="text-align: left;" class="field__control">{{info.sex == 1?'男':'女'}}</div>
            </div>
          </div>
        </div>


               <div class="van-cell van-field">
          <div class="van-cell__title van-field__label">
            <span>职业</span>
          </div>
          <div class="van-cell__value">
            <div class="van-field__body">
              <div style="text-align: left;" class="field__control">{{info.occup}}</div>
            </div>
          </div>
        </div>

               <div class="van-cell van-field">
          <div class="van-cell__title van-field__label">
            <span>审批管理员</span>
          </div>
          <div class="van-cell__value">
            <div class="van-field__body">
              <div style="text-align: left;" class="field__control">{{info.admin}}</div>
            </div>
          </div>
        </div>

               <div class="van-cell van-field">
          <div class="van-cell__title van-field__label">
            <span>拒绝理由</span>
          </div>
          <div class="van-cell__value">
            <div class="van-field__body">
              <div style="text-align: left;" class="field__control">{{info.reason}}</div>
            </div>
          </div>
        </div>


               <div class="van-cell van-field">
          <div class="van-cell__title van-field__label">
            <span>创建时间</span>
          </div>
          <div class="van-cell__value">
            <div class="van-field__body">
              <div style="text-align: left;" class="field__control"> {{timeFormat(info.create_time)}}</div>
            </div>
          </div>
        </div>


    

       
      </van-cell-group>

    </div>
  </div>
</template>




<script>
import province_list from "@/assets/js/dq.js";

export default {
  name: "detail",
  data() {
    return {
      info: {
        reason: "", //拒绝理由
        real: "", //真实职业
        intention: "", //意向
        channel: "",
        company: "",
        notes: "",
      },

    };
  },
  mounted() {
    let item = this.$route.query.item;
    item = JSON.parse(item || "{}") || {};
    this.info = item;
  },
    filters: {
    // 状态-1报名已拒绝 0待分配 客服 1客服待跟进 2 1审通过 3 2审通过 4 3审通过
    statusMap(state) {
      if (state == -1) {
        return "报名已拒绝";
      }
       if (state == 1) {
        return "客服待跟进";
      }
       if (state == 2) {
        return "审通过";
      }
       if (state == 0) {
        return "待分配客服";
      }
    },
  },
  methods: {
   

    onClickLeft() {
      this.$router.go(-1);
    },

  },
};
</script>

<style lang="scss">
#app {
  background: #eeeeee;
}

.detail-page-return {
  height: 100%;

  &.blurbg {
    background: #057cff;
  }

  .jump-box {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    background: rgba(0, 0, 0, 0.6);
    align-items: center;
    justify-content: center;

    .jump-clr {
      background: #ffffff;
      width: 3.8rem;
      height: 1.8rem;
      align-items: center;
      justify-content: center;
      display: flex;
      border-radius: 0.08rem;
      font-size: 0.32rem;
      text-align: center;
      color: #333;
      position: relative;
      padding-bottom: 0.88rem;
      line-height: 1.4;

      .jump-remove {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        border-top: 1px solid #f4f4f4;
        height: 0.88rem;
        text-align: center;
        color: #666666;
      }
    }
  }

  .detail-page {
    .submit {
      margin-top: 1rem;
      height: 0.75rem;
      background: rgba(127, 207, 241, 1);
      font-size: 0.28rem;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
    }
  }

  .out-top {
    text-align: center;
    line-height: 0.98rem;
  }

  .top-bg-st {
    position: relative;
    height: 2.4rem;
    width: 7.5rem;
    background-image: linear-gradient(to right, #038ed1, #1d208a);
  }

  .content-box {
    position: fixed;
    background: #ffffff;
    top: 1.24rem;
    width: 6.86rem;
    padding-bottom: 1.6rem;
    box-sizing: border-box;
    left: 0;
    right: 0;
    margin: 0 auto;
    border-radius: 0.32rem;
    padding-top: 0.32rem;
    color: #999999;
  }

  .wb-content {
    padding-bottom: 0.24rem;
    box-sizing: border-box;
    left: 0;
    right: 0;
    margin: 0 auto;
    padding-top: 0.32rem;
    color: #999999;
    background: #057cff;

    .wb-logo {
      padding-top: 0.3rem 0 0.55rem;
      margin: 0 auto;
      width: 3.4rem;
      height: auto;
      display: block;
    }

    .wb-text {
      display: block;
      margin: 0 auto;
      width: 4.8rem;
      height: auto;
      padding-bottom: 0.6rem;
    }

    .van-cell-group {
      background: #057cff;
      color: #fff;

      .van-cell {
        background: #057cff;
        color: #fff;

        input {
          background: #057cff;
          color: #fff;
        }
      }
    }

    input::input-placeholder {
      color: #ffffff !important;
    }

    input::-webkit-input-placeholder {
      color: #ffffff !important;
    }

      input:-moz-placeholder {
      color: #ffffff !important;
    }

      input::-moz-placeholder {
      color: #ffffff !important;
    }

      input:-ms-input-placeholder {
      color: #ffffff !important;
    }

    .wb-submit {
      margin: 0.55rem auto 0.34rem;
      width: 5.5rem;
      height: 0.8rem;
      background-image: linear-gradient(to right, #ffc200, #ff5900);
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 0.4rem;
    }

    .has-zh {
      line-height: 1;
      font-size: 0.32rem;
      color: #ffffff;
      text-align: center;
      height: 2.8rem;
      background: url("https://qn.xwyyjt.com/ht_kh_yq_bg.png") no-repeat 0
        0.2rem;
      background-size: 60%;
    }
  }

  .wb-form {
    padding: 0 1rem;
  }

  .van-cell,
  .van-cell__value,
  .van-field__control {
    color: #999999;
  }

  .btn-blur {
    border-radius: 0.12rem;
    margin-top: 0.12rem;
    padding: 0.12rem 0.32rem;
    border-right: 0.32rem;
    width: 1.6rem;
    background-image: linear-gradient(to right, #038ed1, #1d208a);
    color: #ffffff;
  }

  .submit {
    margin: 0.42rem auto 0;
    width: 4rem;
    height: 0.72rem;
    background-image: linear-gradient(to right, #038ed1, #1d208a);
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  [class*="van-hairline"]::after {
    border: none;
  }
  .van-cell:last-child::after {
    position: absolute;
    box-sizing: border-box;
    content: " ";
    pointer-events: none;
    right: 0;
    bottom: 0;
    left: 16px;
    border-bottom: 1px solid #ebedf0;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/returnView.vue